import apiClient, { retryRequest } from "./axios";

// 机场相关API
export const airportApi = {
    // 获取机场列表
    getAirportList: async (params = {}) => {
        try {
            const response = await apiClient.get("/v1/airports", { params });
            return response;
        } catch (error) {
            console.error("获取机场列表失败:", error);
            // 如果API失败，重新抛出异常让上层处理
            throw error;
        }
    },

    // 获取单个机场
    getAirportByCode: async (iataCode) => {
        try {
            const response = await apiClient.get(`/v1/airports/${iataCode}`);
            return response;
        } catch (error) {
            console.error("获取机场信息失败:", error);
            throw error;
        }
    },

    // 获取机场约束信息（宵禁规则和最小过站时间）- 可选择特定机场
    getAirportConstraints: async (iataCode = null) => {
        try {
            const params = iataCode ? { code: iataCode } : {};
            const response = await apiClient.get("/v1/airport-constraints", { params });

            return response;
        } catch (error) {
            console.error("获取机场约束信息失败:", error);
            // 即使API失败也重新抛出异常
            throw error;
        }
    },

    // 获取所有机场约束数据（一次性加载所有宵禁规则和最小过站时间）
    getAllAirportConstraints: async () => {
        try {
            const response = await apiClient.get("/v1/airport-constraints/all");

            return response;
        } catch (error) {
            console.error("获取所有机场约束信息失败:", error);
            // 返回空数组改为抛出异常
            throw error;
        }
    },

    // 创建机场
    createAirport: async (data) => {
        const response = await apiClient.post("/v1/airports", data);
        return response;
    },

    // 更新机场
    updateAirport: ({ id, data }) => {
        return apiClient.put(`/v1/airports/${id}`, data);
    },

    // 删除机场
    deleteAirport: (iataCode) => {
        return apiClient.delete(`/v1/airports/${iataCode}`);
    },
};

// 飞机资源相关API
export const aircraftApi = {
    // 获取飞机列表
    getAircraftList: async (params = {}) => {
        try {
            const response = await apiClient.get("/v1/aircraft", { params });
            return response;
        } catch (error) {
            console.error("获取飞机列表失败:", error);
            // 返回空数组改为抛出异常
            throw error;
        }
    },

    // 获取单个飞机
    getAircraftById: async (id) => {
        try {
            const response = await apiClient.get(`/v1/aircraft/${id}`);
            return response;
        } catch (error) {
            console.error("获取飞机信息失败:", error);
            throw error;
        }
    },

    // 创建飞机
    createAircraft: (data) => {
        return apiClient.post("/v1/aircraft", data);
    },

    // 更新飞机
    updateAircraft: ({ id, data }) => {
        return apiClient.put(`/v1/aircraft/${id}`, data);
    },

    // 删除飞机
    deleteAircraft: (id) => {
        return apiClient.delete(`/v1/aircraft/${id}`);
    },
};

// 导出所有API
export const masterDataApi = {
    aircraft: aircraftApi,
    airport: airportApi,
};

export default masterDataApi;
